export enum STUDENTS_ERRORS {
    EMPTY_TEAM = 'empty_team',
    EMPTY_SCHOOL_AND_TEAM = 'empty_school_and_team',
    NO_STUDENTS_SELECTED = 'no_students_selected',
    EMPTY_SCHOOL = 'empty_school',
}
